import React from "react"
import { diff_in_days } from "../../utils/dates/diff_in_days"

const MAX_DAYS_FOR_COMING_AT_FUTURE = 90

function ComingSoon(props) {
  // -------------------------------------
  // Props destructuring
  // -------------------------------------

  const { sDate } = props

  // -------------------------------------
  // Hooks (e.g. useState, useMemo ...)
  // -------------------------------------

  // -------------------------------------
  // Effects
  // -------------------------------------

  // -------------------------------------
  // Component functions
  // -------------------------------------

  // -------------------------------------
  // Component local variables
  // -------------------------------------

  const days = diff_in_days(sDate)
  const date = new Date(sDate)
  const formattedDate = `${date.getDate()}/${date.getMonth() + 1}`

  // -------------------------------------

  return (
    <span>
      {days > MAX_DAYS_FOR_COMING_AT_FUTURE
        ? I18n.t("pages.locations.venues.venue_box.coming_at_future")
        : I18n.t("pages.locations.venues.venue_box.coming_at", {
            date: formattedDate,
          })}
    </span>
  )
}

export default ComingSoon
